var _path, _mask, _path2, _path3, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 470,
    height: 473,
    fill: "none",
    viewBox: "0 0 470 473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 8,
    d: "M437.5 86v333.5c0 11.046-8.954 20-20 20H56c-11.046 0-20-8.954-20-20v-367c0-11.046 8.954-20 20-20h330.752c3.014 0 5.878 1.315 7.844 3.6v0M437.5 86l-42.904-49.9M437.5 86h-24.721c-11.533 0-20.676-9.728-19.961-21.238l1.778-28.662"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225 242.184c0-19.312-7.586-37.834-21.088-51.489-13.503-13.656-31.816-21.328-50.912-21.328s-37.409 7.672-50.912 21.328C88.586 204.35 81 222.872 81 242.184h144z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 16,
    d: "M225 242.184c0-19.312-7.586-37.834-21.088-51.489-13.503-13.656-31.816-21.328-50.912-21.328s-37.409 7.672-50.912 21.328C88.586 204.35 81 222.872 81 242.184h144z",
    mask: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 8,
    d: "M187.988 130.684c0 19.153-15.535 34.683-34.703 34.683-19.169 0-34.704-15.53-34.704-34.683 0-19.154 15.535-34.684 34.704-34.684 19.168 0 34.703 15.53 34.703 34.684z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 8,
    d: "M264 105h130M264 137h130M264 169h130M264 201h130M264 233h130"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 8,
    d: "M84 277h308M84 305h308M84 333h308M84 361h308"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.47cbca318f354d1339be60764618ae5a.svg";
export { ForwardRef as ReactComponent };